import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const GetAdmissionsKpiRequestDtoSchema = z.object({
  from: z.string(),
  to: z.string(),
  facilityId: z.number().optional(),
});

const GetAdmissionsKpiResponseDtoSchema = z.object({
  count: z.number(),
  changePct: z.number().nullable(),
});

export type GetAdmissionsKpiRequestDto = z.infer<
  typeof GetAdmissionsKpiRequestDtoSchema
>;
export type GetAdmissionsKpiResponseDto = z.infer<
  typeof GetAdmissionsKpiResponseDtoSchema
>;

export const getAdmissionsKpi = (
  params: GetAdmissionsKpiRequestDto,
  config?: AxiosRequestConfig<GetAdmissionsKpiRequestDto>
) => {
  const validatedParams = GetAdmissionsKpiRequestDtoSchema.parse(params);
  return api
    .get('/residents/admissions', {
      params: validatedParams,
      ...config,
    })
    .then(responseContract(GetAdmissionsKpiResponseDtoSchema));
};
